"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepSlotsOfNodeType = stepSlotsOfNodeType;
exports.prepareStep = prepareStep;
const workflow_graph_1 = require("./workflow-graph");
/**
 * The slots of the node type for a new step; a config slot named in
 * `slotValues` starts with that value. No node type, no slots.
 */
function stepSlotsOfNodeType(nodeType, slotValues = {}) {
    if (!nodeType)
        return { inputSlots: [], configSlots: [], outputSlots: [] };
    const configSlots = (nodeType.configSlots ?? []).map(slot => slotValues[slot.name] !== undefined
        ? { ...slot, value: slotValues[slot.name] }
        : slot);
    return {
        inputSlots: [...(nodeType.inputSlots ?? [])],
        configSlots,
        outputSlots: [...(nodeType.outputSlots ?? [])],
    };
}
/** A new step with its own id, ready for `insertPreparedStep`. */
function prepareStep(input, generateId = workflow_graph_1.generateStepId) {
    const id = generateId('step');
    return {
        id,
        name: input.stepName ?? `${input.stepType}-${id.slice(-4)}`,
        type: input.stepType,
        config: input.config,
        position: { x: 0, y: 0 },
        ...input.slots,
    };
}
